import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OutputNumber from '../OutputNumber';
import OutputUnit from '../OutputUnit';
import OutputNumberUnitLayout from '../OutputNumberUnitLayout';
import './styles.css';

class OutputNumberUnit extends Component {
	render() {
		const { unit, variable, multiplier, decimals } = this.props;
		return (
			<OutputNumberUnitLayout>
				<OutputNumber variable={variable} multiplier={multiplier} decimals={decimals} />
				<OutputUnit unit={unit} />
			</OutputNumberUnitLayout>
		);
	}
}

OutputNumberUnit.propTypes = {
	unit: PropTypes.string,
	variable: PropTypes.object
};
export default OutputNumberUnit;
